module.exports = "pegasus/assets/theme2/header-image.jpg";